<template>
    <div class="sup-faq-comp">
        <div class="re-w1200 re-main-col">
            <div class="type-title-box">
                <div class="title-blue-line"></div>
                <span class="title">FAQ</span>
                <img src="@/assets/imgs/devDoc/more_btn.png" @click="jump_faq_click" />
            </div>
            <div class="grid-list-box">
                <div class="grid-item-box" v-for="(item, index) in faq_msg_list" :key="`item_${index}`" @click="faq_item_click(item)">
                    <img class="item-icon" src="@/assets/imgs/devDoc/faq_icon.png" />
                    <span class="item-title">{{ item.title }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, computed } from 'vue';
import { useRouterStore } from '@/stores/router';

const router_store = useRouterStore();

const props = defineProps({
    faq_msg_list: {
        type: Array,
        default: () => [],
    },
});

// MARK Click  跳转FAQ
const jump_faq_click = () => {
    router_store.navigateToFaq();
};
// MARK Click Item  faq点击
const faq_item_click = (item) => {
    router_store.navigateToFaq({ docId: item.id, treeId: item.dcId, shareType: 1 });
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-faq-comp {
    position: relative;
    display: flex;
    justify-content: center;

    .type-title-box {
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;

        .title-blue-line {
            position: relative;
            width: 6px;
            height: 48px;
            border-radius: 1px;
            background: var(--color-main-brand);
        }

        .title {
            position: relative;
            margin-left: 20px;
            height: 48px;
            flex: 1;
            font-weight: 400;
            font-size: 32px;
            color: var(--color-main-text-primary);
        }

        img {
            position: relative;
            margin-right: 0;
            width: 36px;
            height: 36px;
            cursor: pointer;
            border-radius: 18px;
            outline: 0 solid transparent;
            transition: var(--animation-outline-style);

            &:hover {
                outline: 4px solid var(--color-main-outline-hover);
            }
        }
    }

    .grid-list-box {
        position: relative;
        width: 100%;
        margin-top: 47px;
        flex-shrink: 0;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        column-gap: 40px;
        row-gap: 26px;

        .grid-item-box {
            position: relative;
            display: flex;
            align-items: center;
            height: 66px;
            padding: 0 40px;
            box-sizing: border-box;
            border: 2px solid var(--color-main-transparent-bg);
            border-radius: 3px;
            cursor: pointer;
            background-color: var(--color-main-dev-center-faq-bg);
            transition: var(--animation-border-style);

            .item-icon {
                position: relative;
                width: 28px;
                height: 28px;
            }

            .item-title {
                position: relative;
                margin-left: 17px;
                height: 26px;
                font-weight: 400;
                font-size: 17px;
                line-height: 26px;
                color: var(--color-main-text-primary);
            }

            &:hover {
                border: 2px solid var(--color-main-brand-hover);
            }
        }
    }
}
</style>
